module.exports = __webpack_public_path__ + "img/抖音-UA官方账号二维码-s.29a5938.png";